import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {MaintenanceCalendarService} from '../../../services/maintenance-calendar.service';


@Component({
    selector: 'maintenance-calendar-view',
    templateUrl: './maintenance-calendar-view.component.html',
    styleUrls: ['./maintenance-calendar-view.component.scss']
})
export class MaintenanceCalendarViewComponent implements OnInit {

    activeTab = 'subtasks';
    showModal = false;

    constructor(
        public api: ApiClientService,
        public maintenanceCalendarService: MaintenanceCalendarService
    ) {

    }

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
    }

    changeTab(tab) {
        this.activeTab = tab;
    }


    hideModal() {
        this.maintenanceCalendarService.isAmenityViewShow = false;
        this.maintenanceCalendarService.amenityInAmenityModal = null;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-view/maintenance-calendar-view.component.ts